import CrudSection from "../components/CrudSection";
import { StatusTextBadge } from "../../../components/base/StatusTextBadge";
import type { CrudColumn, CrudField } from "../types";

// ===========================================================================
// Control de acceso — secciones con datos de ejemplo que aún no pasan al API (las demás viven en ../screens, CC-CONSOLE #1593) (mock data, interactive in-session).
// ===========================================================================

// --- Permisos por perfil ---------------------------------------------------
interface Permiso extends Record<string, unknown> {
  id: string; perfil: string; puntos: string; horario: string; estado: string;
}
const permisoColumns: CrudColumn<Permiso>[] = [
  { key: "perfil", label: "Perfil" },
  { key: "puntos", label: "Puntos de acceso" },
  { key: "horario", label: "Horario" },
  { key: "estado", label: "Estado", align: "center", render: (r) => <StatusTextBadge value={r.estado} /> },
];
const permisoFields: CrudField[] = [
  { key: "perfil", label: "Perfil", type: "select", required: true, options: [
    { value: "Residente", label: "Residente" }, { value: "Miembro", label: "Miembro" },
    { value: "Visitante", label: "Visitante" }, { value: "Proveedor", label: "Proveedor" },
  ] },
  { key: "puntos", label: "Puntos de acceso", required: true, placeholder: "Todos / Lobby / ..." },
  { key: "horario", label: "Horario", required: true, placeholder: "24/7 o 08:00–18:00" },
  { key: "estado", label: "Estado", type: "select", defaultValue: "Activo", options: [
    { value: "Activo", label: "Activo" }, { value: "Inactivo", label: "Inactivo" },
  ] },
];
const permisoSeed: Permiso[] = [
  { id: "r1", perfil: "Residente", puntos: "Todos", horario: "24/7", estado: "Activo" },
  { id: "r2", perfil: "Visitante", puntos: "Caseta, Lobby", horario: "08:00–22:00", estado: "Activo" },
  { id: "r3", perfil: "Proveedor", puntos: "Acceso de servicio", horario: "07:00–15:00", estado: "Activo" },
  { id: "r4", perfil: "Miembro", puntos: "Amenidades", horario: "06:00–23:00", estado: "Inactivo" },
];
export const PermisosSection = () => (
  <CrudSection<Permiso> title="Permisos por perfil" subtitle="Reglas de acceso por tipo de persona"
    icon="ri-shield-keyhole-line" columns={permisoColumns} fields={permisoFields} seed={permisoSeed} searchKey="perfil" />
);
